import{MAPBOX_LIMITS}from"./map-state";function decapitalize(s){return s[0].toLowerCase()+s.slice(1)}export function checkVisibilityConstraints(props){var constraints=1<arguments.length&&arguments[1]!==void 0?arguments[1]:MAPBOX_LIMITS;for(var constraintName in constraints){var type=constraintName.slice(0,3),propName=decapitalize(constraintName.slice(3));if("min"===type&&props[propName]<constraints[constraintName])return!1;if("max"===type&&props[propName]>constraints[constraintName])return!1}return!0}
//# sourceMappingURL=map-constraints.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/esm/utils/map-constraints.js
// module id = 1666
// module chunks = 0